import React, { FC, useState, useEffect } from 'react';
import imagePng from 'images/hero.png';
import logoPng from 'images/mh_logo.png';
import HeroRealEstateSearchForm from 'components/HeroSearchForm/HeroRealEstateSearchForm';
import StatsTicker from 'components/StatsTicker';
import useWindowSize from 'hooks/useWindowResize';
import { getNumberOfProperties, getStatistics } from 'data/DataController';

export interface SectionHero2ArchivePageProps {
  className?: string;
  children?: React.ReactNode;
}

const SectionHero2ArchivePage: FC<SectionHero2ArchivePageProps> = ({
  className = '',
  children,
}) => {
  const windowSize = useWindowSize();
  const mobileMinWidthBreakpoint = 768;

  const [numberOfProperties, setNumberOfProperties] = useState(100);
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    // Ingatlanok száma lekérése
    getNumberOfProperties('hu').then((response) => {
      setNumberOfProperties(response[0]['number_of_properties']);
    });

    // Statisztikák lekérése
    getStatistics().then((data) => {
      setStatistics(data);
    });
  }, []);

  const renderMobileHeroSearch = () => {
    return (
      <button
        onClick={() => console.log('')}
        className='relative flex items-center w-full border border-neutral-200 dark:border-neutral-6000 px-4 py-2 pr-11 rounded-full shadow-lg'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          strokeWidth={1.5}
          stroke='currentColor'
          className='w-6 h-6'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z'
          />
        </svg>

        <div className='ml-3 flex-1 text-left overflow-hidden'>
          <span className='block font-medium text-sm'>Keresés</span>
          <span className='block mt-0.5 text-xs font-light text-neutral-500 dark:text-neutral-400 line-clamp-1'>
            Multihome Ingatlanok
          </span>
        </div>

        <span className='absolute right-2 top-1/2 transform -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full border border-neutral-200 dark:border-neutral-6000 dark:text-neutral-300'>
          <svg
            viewBox='0 0 16 16'
            aria-hidden='true'
            role='presentation'
            focusable='false'
            className='block w-4 h-4'
            fill='currentColor'
          >
            <path d='M5 8c1.306 0 2.418.835 2.83 2H14v2H7.829A3.001 3.001 0 1 1 5 8zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm6-8a3 3 0 1 1-2.829 4H2V4h6.17A3.001 3.001 0 1 1 11 2zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'></path>
          </svg>
        </span>
      </button>
    );
  };

  return (
    <div
      className={`nc-SectionHero flex flex-col lg:flex-col relative ${className}`}
      data-nc-id='SectionHero'
    >
      {/* Statisztika ticker hozzáadása a tetejére */}
      <StatsTicker stats={statistics} />

      <div className='hidden sm:flex sm:flex-col lg:flex-row lg:items-center'>
        <div className='flex-grow'>
          <div className='relative w-full h-full'>
            <img className='w-full' src={imagePng} alt='hero' />
            <div className='absolute inset-0 bg-white bg-opacity-60 backdrop-blur-sm'></div>
            <div className='absolute inset-0 flex items-center justify-center'>
              <img src={logoPng} alt='logo' className='max-w-full h-auto' />
            </div>
          </div>
        </div>

        <h2 className='block sm:hidden font-semibold text-4xl mt-10 !leading-[114%]'>
          Multihome
        </h2>
        <h3 className='block sm:hidden font-semibold text-2xl mt-10'>
          <span style={{ color: '#17BED0' }}>Az ingatlan</span> k
          <span style={{ color: '#17BED0' }}>örül</span>
        </h3>
      </div>

      <div className='container -mt-0 lg:-mt-24 relative z-10'>
        <HeroRealEstateSearchForm />
      </div>
    </div>
  );
};

export default SectionHero2ArchivePage;
